import axios from "axios";
import Cookies from "js-cookie";

const SkySparkGrid = async (expression) => {
    try {
        const headers = { "Authorization": "BEARER authToken=" + Cookies.get('skyarc-auth-8080'), "Accept": "application/json" }
        const dataResponse = await axios.get(`https://infinity.skyspark.nl/api/portal/eval?expr=${expression}`, {
            headers
        })
        return dataResponse;
    } catch (error) {
        console.log('Error detected: ', error)
        return []
    }
}

export default SkySparkGrid;